import { ROUTES } from '@/utils/constants';
import { removeProductFromUid } from '@/utils/url/url';

/**
 * Hub-style routes (Epic Hub, Influencer Hub, Gameplay Session) all carry a slug
 * with a product prefix (e.g. `casino-roulette`). The aggregation `getPageConfig`
 * expects a plain category route without the hub segment or product prefix
 * (e.g. `/c/roulette`), so any of these is mapped to `/c/<slug-without-product>`.
 *
 * Non-hub routes are returned unchanged.
 */
const HUB_ROUTE_PREFIXES = [ROUTES.CATEGORY_HUB, ROUTES.INFLUENCER_HUB, ROUTES.GAMEPLAY_SESSION];

export const normalizeRouteForPageConfig = (route: string): string => {
    const matchedPrefix = HUB_ROUTE_PREFIXES.find((prefix) => route.startsWith(prefix));
    if (!matchedPrefix) {
        return route;
    }
    const slug = route.slice(matchedPrefix.length);
    return `${ROUTES.CATEGORY}${removeProductFromUid(slug)}`;
};
